// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fi-3";
export var flatBottomCorners = "_fi-5";
export var productImage = "_fi-0";
export var quantityContainer = "_fi-2";
export var quantityHeader = "_fi-6";
export var tooltip = "_fi-1";
export var wrapAndEllipsesOverflow = "_fi-4";